/* global Foundation */
import $ from 'jquery'

export function initServiceAreas () {
  const body = document.body

  if (
    !body.classList.contains('supplier_onboardings-controller') ||
    !body.classList.contains('business_info-action')
  ) return

  const $container = $('#business-info')
  if ($container.length === 0) return

  function countCountiesInState (state) {
    const count = $(`.county[data-state='${state}']:checked`).length
    const $stateSection = $(`.accordion-item[data-state='${state}']`)
    const totalCounties = $stateSection.data('total-counties')

    $stateSection.removeClass('all-counties some-counties')
    if (count === totalCounties) {
      $stateSection.addClass('all-counties')
    } else if (count > 0) {
      $stateSection.addClass('some-counties')
    }

    $(`.county-count[data-state='${state}']`).text(count)
  }

  function countCountiesInAllStates () {
    $('.accordion-item').each(function () {
      const state = $(this).data('state')
      countCountiesInState(state)
    })
  }

  function recordCountySelection () {
    const countySelection = []
    $('.county:checked').each(function () {
      countySelection.push(this.value)
    })
    $('#county-selection').val(countySelection.join(','))
  }

  function checkServiceAreas () {
    let updating = $('.service-areas-container').data('updating')
    if (!updating) return

    const supplierId = $('.service-areas-container').data('supplier-id')
    let timesExecuted = 0

    const intervalId = setInterval(function () {
      updating = $('.service-areas-container').data('updating')
      if (updating) {
        $.ajax(`/suppliers/${supplierId}/onboarding/service_areas_updating.js?source=edit`)
          .done(function () {
            if (window.Foundation) {
              Foundation.ReInit($('.accordion'))
              countCountiesInAllStates()
              Foundation.ReInit($('.sticky'))
            }
          })
        timesExecuted++
      }

      if (!updating || timesExecuted === 60) {
        clearInterval(intervalId)
      }
    }, 5000)
  }

  countCountiesInAllStates()
  checkServiceAreas()

  $container.on('submit', '.service-area-form', function () {
    $('.county').prop('readonly', true)
    recordCountySelection()
  })

  $container.on('click', '.select-all-counties', function (e) {
    e.preventDefault()
    $('.county').prop('checked', true)
    countCountiesInAllStates()
  })

  $container.on('click', '.clear-all-counties', function (e) {
    e.preventDefault()
    $('.county').prop('checked', false)
    countCountiesInAllStates()
  })

  $container.on('click', '.select-all-state-counties', function (e) {
    e.preventDefault()
    const state = $(this).data('state')
    $(`.county[data-state='${state}']`).prop('checked', true).trigger('change')
  })

  $container.on('click', '.clear-all-state-counties', function (e) {
    e.preventDefault()
    const state = $(this).data('state')
    $(`.county[data-state='${state}']`).prop('checked', false).trigger('change')
  })

  $container.on('change', '.county', function () {
    const state = $(this).data('state')
    countCountiesInState(state)
  })
}
